import { TEST_ID_AI_PLAYER_SUMMARY } from "e2e/testId";
import { memo } from "react";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props interface for AIPlayerSummaryErrorStateView component
 */
interface AIPlayerSummaryErrorStateViewProps {
  error: string;
  isDark: boolean;
  isSmallScreen: boolean;
  onRefresh: () => void;
}

/**
 * AIPlayerSummaryErrorStateView component - pure UI for error state
 *
 * Displays an error message and a "Try Again" button when AI summary generation fails.
 * @param props - Component props
 * @param props.error - Error message to display
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.onRefresh - Callback to refresh and regenerate the summary
 */
const AIPlayerSummaryErrorStateView = ({
  error,
  isSmallScreen,
  onRefresh,
}: AIPlayerSummaryErrorStateViewProps) => (
  <Stack
    className={`items-center justify-center gap-3 ${isSmallScreen ? "py-4" : "py-6"}`}
  >
    <Text variant="body" className="text-center text-status-error">
      {error}
    </Text>
    <Button
      testID={TEST_ID_AI_PLAYER_SUMMARY.TRY_AGAIN_BUTTON}
      label="Try Again"
      tone="primary"
      size="sm"
      onPress={onRefresh}
    />
  </Stack>
);

AIPlayerSummaryErrorStateView.displayName = "AIPlayerSummaryErrorStateView";

export default memo(AIPlayerSummaryErrorStateView);
